import { lazyLoadComponent } from '@/utils/helper'

// import Roles from '@/utils/role'

export default [
  {
    path: '/admin',
    component: lazyLoadComponent('admin/Home'),
    name: 'Account Inventory',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  // {
  //   path: '/onboarding',
  //   component: AdminHome,
  //   name: 'AWS Account Onboarding',
  //   meta: {
  //     requiresAuth: true,
  //     view: 'admin',
  //     permission: [],
  //     fail: '/404.html'
  //   }
  // },
  {
    path: '/admin/financial-administration/monthly-cross-charge',
    component: lazyLoadComponent('admin/financeAdmin/FinanceMonthlyCrossCharge'),
    name: 'Monthly Cross Charge',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/financial-administration/dashboard',
    component: lazyLoadComponent('admin/financeAdmin/FinanceDashboard'),
    name: 'Dashboard',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/financial-administration/burndown-reporting',
    component: lazyLoadComponent('admin/financeAdmin/FinanceBurndownReporting'),
    name: 'Burndown Reporting',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/financial-administration/admin-section-update-records',
    component: lazyLoadComponent('admin/financeAdmin/FinanceAdminUpdateRecords'),
    name: 'Admin Section - Update Records',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/account-inventory/aws-agreement',
    component: lazyLoadComponent('admin/accountInventory/AwsAgreement'),
    name: 'Account Inventory - AWS Agreement',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/account-inventory/master-payer',
    component: lazyLoadComponent('admin/accountInventory/ByMasterPayer'),
    name: 'Account Inventory - Master Payer',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/account-inventory/master-payer/:id',
    component: lazyLoadComponent('admin/accountInventory/MasterPayerList'),
    name: 'Account Inventory - Master Payer List',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/master-payer-report',
    component: lazyLoadComponent('admin/accountInventory/MasterPayerReport'),
    name: 'Master Payer Report',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/master-payer-report/list/:status',
    component: lazyLoadComponent('admin/accountInventory/MasterPayerReportList'),
    name: 'Master Payer Report List',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/account-inventory/customers',
    component: lazyLoadComponent('admin/accountInventory/ByCustomer'),
    name: 'Account Inventory - By Customers',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/account-inventory/customers/:id',
    component: lazyLoadComponent('admin/accountInventory/ByCustomerList'),
    name: 'Account Inventory - By Customer',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/account-inventory/linked-account',
    component: lazyLoadComponent('admin/accountInventory/LinkedAccount'),
    name: 'Account Inventory - Linked Account',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/oppreg-administration',
    component: lazyLoadComponent('admin/oppregAdmin/Home'),
    name: 'Oppreg Admin',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/oppreg-administration/admin-content',
    component: lazyLoadComponent('admin/oppregAdmin/AdminList'),
    name: 'OppReg Admin List',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/oppreg-administration/admin-content/:id',
    component: lazyLoadComponent('admin/oppregAdmin/UpdateAdminContent'),
    name: 'OppReg Admin List Detail',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },

  {
    path: '/admin/oppreg-administration/general-reporting',
    component: lazyLoadComponent('admin/oppregAdmin/GeneralReporting'),
    name: 'Reports and Extracts',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/oppreg-administration/view-all-registrations',
    component: lazyLoadComponent('admin/oppregAdmin/ViewAllRegistrations'),
    name: 'View All Registrations',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/oppreg-administration/draft-opportunities',
    component: lazyLoadComponent('admin/oppregAdmin/DraftOpportunities'),
    name: 'Draft Opportunities',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/onboard-aws-account/view-request',
    component: lazyLoadComponent('admin/accountOnboarding/ViewRequest'),
    name: 'View Request',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },

  // {
  //   path: '/admin/onboard-aws-account/process-new',
  //   component: AccountOnboardingProcessNewRequest,
  //   name: 'Process New Account Request',
  //   meta: {
  //     requiresAuth: true,
  //     view: 'admin',
  //     permission: [],
  //     fail: '/404.html'
  //   }
  // },

  {
    path: '/admin/onboard-aws-account/update-workflow',
    component: lazyLoadComponent('admin/accountOnboarding/UpdateOnboardingWorkflow'),
    name: 'Update Account Onboarding Workflow',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },

  {
    path: '/admin/onboard-masterpayer/view-request',
    component: lazyLoadComponent('admin/masterpayerOnboarding/ViewRequest'),
    name: 'View Request',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },

  {
    path: '/admin/onboard-masterpayer/new',
    component: lazyLoadComponent('admin/masterpayerOnboarding/ViewRequestDetail'),
    name: 'New Request',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  

  {
    path: '/admin/onboard-masterpayer/view-request/:id',
    component: lazyLoadComponent('admin/masterpayerOnboarding/ViewRequestDetail'),
    name: 'View Request Detail',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },

  {
    path: '/admin/customers',
    component: lazyLoadComponent('admin/CustomerList'),
    name: 'Customers List',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/master-payer',
    component: lazyLoadComponent('admin/MasterPayerList'),
    name: 'MasterPayer Accounts List',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/email-audit-trail',
    component: lazyLoadComponent('admin/AuditTrail'),
    name: 'Email Audit Trail',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/attestations/view-requests',
    component: lazyLoadComponent('admin/attestations/Attestations'),
    name: 'Attestations Page',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/attestations/view-requests/:id',
    component: lazyLoadComponent('admin/attestations/AttestationsEdit'),
    name: 'Attestations Page',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/admin/request-managed-services/view-request',
    component: lazyLoadComponent('admin/requestManagedServices/ViewRequest'),
    name: 'Customer Owned Accounts - Request Managed Svcs',
    meta: {
      requiresAuth: true,
      view: 'admin',
      permission: [],
      fail: '/404.html'
    }
  },
  // {
  //   path: '/admin/financial-administration/monthly-cross-charge/aws-agreement',
  //   component: lazyLoadComponent('admin/financeAdmin/monthlyCrossCharge/ByAwsAgreement'),
  //   name: 'MCC - By AWS Agreement',
  //   meta: {
  //     requiresAuth: true,
  //     view: 'admin',
  //     permission: [],
  //     fail: '/404.html'
  //   }
  // },
  // {
  //   path: '/admin/financial-administration/monthly-cross-charge/master-payer',
  //   component: lazyLoadComponent('admin/financeAdmin/monthlyCrossCharge/ByMasterPayer'),
  //   name: 'MCC - By Master Payer',
  //   meta: {
  //     requiresAuth: true,
  //     view: 'admin',
  //     permission: [],
  //     fail: '/404.html'
  //   }
  // },
  // {
  //   path: '/admin/financial-administration/monthly-cross-charge/master-payer/:id',
  //   component: lazyLoadComponent('admin/financeAdmin/monthlyCrossCharge/ByMasterPayerList'),
  //   name: 'MCC - By Master Payer List',
  //   meta: {
  //     requiresAuth: true,
  //     view: 'admin',
  //     permission: [],
  //     fail: '/404.html'
  //   }
  // },
  // {
  //   path: '/admin/financial-administration/monthly-cross-charge/customers',
  //   component: lazyLoadComponent('admin/financeAdmin/monthlyCrossCharge/ByCustomer'),
  //   name: 'MCC - By Customer',
  //   meta: {
  //     requiresAuth: true,
  //     view: 'admin',
  //     permission: [],
  //     fail: '/404.html'
  //   }
  // },
  // {
  //   path: '/admin/financial-administration/monthly-cross-charge/customers/:id',
  //   component: lazyLoadComponent('admin/financeAdmin/monthlyCrossCharge/ByCustomerList'),
  //   name: 'MCC - By Customer List',
  //   meta: {
  //     requiresAuth: true,
  //     view: 'admin',
  //     permission: [],
  //     fail: '/404.html'
  //   }
  // },
  // {
  //   path: '/admin/financial-administration/monthly-cross-charge/linked-account',
  //   component: lazyLoadComponent('admin/financeAdmin/monthlyCrossCharge/ByLinkedAcct'),
  //   name: 'MCC - By Linked Account',
  //   meta: {
  //     requiresAuth: true,
  //     view: 'admin',
  //     permission: [],
  //     fail: '/404.html'
  //   }
  // },
  // {
  //   path: '/admin/financial-administration/monthly-cross-charge/linked-account/:id',
  //   component: lazyLoadComponent('admin/financeAdmin/monthlyCrossCharge/ByLinkedAcctList'),
  //   name: 'MCC - By Linked Account List',
  //   meta: {
  //     requiresAuth: true,
  //     view: 'admin',
  //     permission: [],
  //     fail: '/404.html'
  //   }
  // }
]
